export const en = {
  common: {
    appName: 'Moussenaires',
    loading: 'Loading…',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    confirm: 'Confirm',
    back: 'Back',
    search: 'Search',
    optional: 'optional',
    somethingWrong: 'Something went wrong',
    retry: 'Retry',
    empty: 'Nothing to show yet.',
    yes: 'Yes',
    no: 'No',
    online: '{{count}} online',
  },
  nav: {
    roster: 'Roster',
    feed: 'Forum',
    admin: 'Admin',
    login: 'Log in',
    logout: 'Log out',
    profile: 'Profile',
    settings: 'Settings',
    notifications: 'Notifications',
  },
  auth: {
    title: 'Log in',
    subtitle: 'A private space for the guild.',
    username: 'Username',
    password: 'Password',
    submit: 'Log in',
    invalidCredentials: 'Invalid username or password.',
    rateLimited: 'Too many attempts, try again in a few minutes.',
    impersonating: "You're viewing the site as {{username}}.",
    stopImpersonating: 'Back to my account',
  },
  roster: {
    title: 'Roster',
    subtitle: 'Players, their characters, and their exploits.',
    private: 'This roster is private — sign in to view it.',
    players: 'Players',
    playerCount: '{{count}} player',
    playerCount_other: '{{count}} players',
    characterCount: '{{count}} character',
    characterCount_other: '{{count}} characters',
    rerolls: '{{count}} reroll',
    rerolls_other: '{{count}} rerolls',
    avgItemLevel: 'Average item level',
    bestScore: 'Best M+ score',
    main: 'Main',
    reroll: 'Reroll',
    alt: 'Alt',
    bank: 'Bank',
    tank: 'Tank',
    healer: 'Healer',
    dps: 'DPS',
    itemLevel: 'ILvl',
    mythicPlusScore: 'M+ score',
    tenPlusKeys: '10+ keys',
    bestKeyLevel: 'Best key',
    progress: 'Progress',
    achievementPoints: 'Achievement points',
    pvpRating: 'PvP rating',
    logs: 'Combat logs',
    addLog: 'Add a log',
    noLogs: 'No logs yet.',
    noCharacters: 'No characters yet.',
    addPlayer: 'Add a player',
    addCharacter: 'Add a character',
    editPlayer: 'Edit player',
    editCharacter: 'Edit character',
    deletePlayerConfirm: 'Delete {{name}} and all their characters?',
    deleteCharacterConfirm: 'Delete {{name}}?',
    name: 'Name',
    realm: 'Realm',
    class: 'Class',
    spec: 'Spec',
    race: 'Race',
    faction: 'Faction',
    level: 'Level',
    role: 'Role',
    kind: 'Kind',
    notes: 'Notes',
    profileUrl: 'Profile link',
    bio: 'Bio',
    linkedAccount: 'Linked account',
    notSyncedYet: 'Not synced yet',
    quickAddHint: 'Everything else (class, gear, score…) is fetched automatically after adding.',
    addAndSync: 'Add and sync',
    syncing: 'Syncing…',
    syncComplete: 'Synced',
    syncingHint: 'Fetching data from the Armory, Raider.IO and Warcraft Logs…',
    sync: 'Sync',
    lastSynced: 'Synced {{time}}',
    equipment: 'Equipment',
    mythicPlus: 'Mythic+',
    recentRuns: 'Recent keys',
    bestRuns: 'Best keys',
    inTime: 'In time',
    notInTime: 'Not in time',
    rankWorld: 'World rank',
    rankRegion: 'Region rank',
    rankRealm: 'Realm rank',
    raidParses: 'Raid parses',
    noRaidParses:
      "No parses found for this raid — either the character hasn't logged there yet, or the configured zone is wrong.",
    boss: 'Boss',
    best: 'Best',
    median: 'Median',
    kills: 'Kills',
    metricDps: 'DPS (best/median)',
    metricHps: 'HPS (best/median)',
    metricBoss: 'Boss DPS (best/median)',
    viewOnWarcraftLogs: 'Warcraft Logs',
    viewOnWowhead: 'View on Wowhead',
    viewOnArmory: 'Armory',
    viewOnRaiderIo: 'Raider.IO',
    recentLogs: 'Recent logs',
    noRecentLogs: 'No recent log found.',
    notConfigured: 'Not configured by an admin.',
    highlightedLogs: 'Highlighted logs',
    difficulty: {
      normal: 'Normal',
      heroic: 'Heroic',
      mythic: 'Mythic',
    },
    selectPlayer: 'For which player?',
    newPlayerOption: '+ New player',
    newPlayerName: "New player's name",
    syncAll: 'Sync all characters',
    syncAllCooldown: 'Next sync in {{time}}',
    sortByRaid: 'Raid',
    sortByMythicPlus: 'Mythic+',
    sortHint: 'Sort by',
    details: 'Details',
    chooseDifficulty: 'Difficulty',
    bestSpec: 'Best',
    viewSection: 'View',
    dungeon: 'Dungeon',
    heroMedia: 'Hero clip',
    heroMediaHint: 'A GIF or a short mp4 clip that replaces the render once this card is focused.',
    heroMediaUpload: 'Upload a clip',
    heroMediaTooLarge: 'Hero clips are limited to 20 MB.',
    playClip: 'Play the clip',
    pauseClip: 'Pause the clip',
  },
  feed: {
    title: 'Forum',
    subtitle: 'Guild memes, clips and exploits.',
    newPost: 'New post',
    postTitle: 'Title',
    postBody: 'Message',
    tags: 'Tags',
    tagsHint: 'Separate tags with a comma.',
    attachments: 'Attachments',
    addLink: 'Add a link',
    linkUrl: 'Link URL',
    dropzone: 'Drop a file here, paste an image, or click to browse.',
    dropzoneActive: 'Drop to add the file',
    uploading: 'Uploading…',
    publish: 'Publish',
    pin: 'Pin',
    unpin: 'Unpin',
    pinned: 'Pinned',
    editedByAdmin: 'Edited by an admin',
    comments: 'Comments',
    commentCount: '{{count}} comment',
    commentCount_other: '{{count}} comments',
    addComment: 'Write a comment…',
    send: 'Send',
    deletePostConfirm: 'Delete this post?',
    deleteCommentConfirm: 'Delete this comment?',
    noPosts: 'No posts yet. Be the first!',
    loadMore: 'Load more',
    searchPlaceholder: 'Search the forum…',
    allTags: 'All tags',
    react: 'React',
    storageWarning: 'Storage is almost full ({{percent}}).',
    storageFull: 'Storage is full — ask an admin to upgrade storage.',
  },
  media: {
    unsupportedType: 'Unsupported file type.',
    fileTooLarge: 'File is too large (max {{max}}).',
    storageLimitReached: 'Storage is full — ask an admin to upgrade storage.',
    uploadFailed: 'Upload failed.',
  },
  admin: {
    title: 'Admin',
    users: 'Users',
    settings: 'Site settings',
    roster: 'Roster',
    addUser: 'Add a user',
    role: 'Role',
    member: 'Member',
    adminRole: 'Admin',
    active: 'Active',
    inactive: 'Deactivated',
    deactivate: 'Deactivate',
    activate: 'Reactivate',
    promote: 'Promote to admin',
    demote: 'Demote to member',
    resetPassword: 'Reset password',
    newPassword: 'New password',
    impersonate: 'Log in as',
    lastAdminError: 'Cannot remove the last remaining admin.',
    siteTitle: 'Site name',
    publicRoster: 'Public roster',
    publicRosterHint: 'When off, the roster requires sign-in.',
    storageLimit: 'Storage limit',
    storageUsed: '{{used}} / {{limit}} used ({{percent}})',
    storageLimitHint: 'Total space allowed for files uploaded to the forum.',
    wowRegion: 'WoW region',
    wowRegionHint:
      "The Blizzard / Raider.IO / Warcraft Logs region the roster's characters live in.",
    warcraftlogsZoneId: 'Warcraft Logs zone (optional)',
    warcraftlogsZoneIdPlaceholder: 'e.g. 44',
    warcraftlogsZoneIdHint:
      "Left blank, Warcraft Logs picks each character's current raid tier automatically — same as browsing their own page. Only set this to force an older tier.",
    defaultTheme: 'Default theme',
    defaultThemeHint: "The guild's own branding — what everyone sees until they pick their own.",
    createUserSuccess: 'User created.',
  },
  notifications: {
    title: 'Notifications',
    empty: 'No notifications.',
    markAllRead: 'Mark all as read',
    'post.created': '{{actor}} posted "{{subject}}"',
    'comment.created': '{{actor}} commented on "{{subject}}"',
    'reaction.created': '{{actor}} reacted to "{{subject}}"',
    'storage.warning': 'Storage: {{subject}}',
    system: '{{subject}}',
    new: 'New',
  },
  settings: {
    title: 'Settings',
    profile: 'Profile',
    displayName: 'Display name',
    avatarUrl: 'Avatar URL',
    language: 'Language',
    theme: 'Theme',
    themeLight: 'Light',
    themeDark: 'Dark',
    themeAlliance: 'Alliance',
    themeHorde: 'Horde',
    themeVoid: 'Void',
    themePoison: 'Poison',
    themeCustom: 'Custom',
    customColors: 'Custom colours',
    colorBg: 'Background',
    colorSurface: 'Surface',
    colorText: 'Text',
    colorAccent: 'Accent',
    colorAccentContrast: 'Text on accent',
    password: 'Password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    changePassword: 'Change password',
    saved: 'Changes saved.',
  },
  errors: {
    validation_failed: 'Some fields are invalid.',
    unauthorized: 'Sign in to continue.',
    invalid_credentials: 'Invalid username or password.',
    forbidden: "You don't have permission to do that.",
    not_found: 'Not found.',
    conflict: 'Conflicts with the current state.',
    payload_too_large: 'File is too large.',
    unsupported_media_type: 'Unsupported file type.',
    storage_limit_reached: 'Storage is full — ask an admin to upgrade storage.',
    rate_limited: 'Too many requests, slow down.',
    internal_error: 'Something went wrong on the server.',
    bad_request: 'Invalid request.',
  },
} as const;
